import React, {  useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { get_not_login_user } from "../../../store/actions/CommanAction";
import DataTable from "react-data-table-component";
import Loader from "../Loader/Loader";
import { customStyles } from "../Utility/Utility";
import Select from "react-select";
import swal from "sweetalert";

const NotLoginUser = () => {
  const dispatch = useDispatch();
  const NotLoginData = useSelector(
    (state) => state.feedBackReducer.GetUserNotUserData
  );
  
 

  const [startTime, setStartTime] = useState("");
  const [loading, setloading] = useState(false);

  const handleSearch = () => {
   
    if(!startTime)
    {
   
    swal(
        "",
        `Please select a day`,
        "warning"
      );
        return
    }

    dispatch(get_not_login_user(startTime,setloading));
  };

  const options = Array.from({ length: 17 }, (_, i) => ({
    value: i + 1,
    label: i + 1,
  }));
  const columns = [
    {
  name: "Name",
  selector: (row) => row.UserName,
  sortable: true,
  
  cell: (row) => (
    <div>
      <div>{row.UserName}({row.UserId})</div>
      
    </div>
  ),
  
},{
      name: "Mobile No",
      selector: (row) => row.MobileNo,
      sortable: true,
    },
    {
        name: "Type",
        // selector: (row) => row.userType,
        
            selector: (row) => (row.userType === "U" ? "User" : row.userType === "A" ? "Astrologer" : row.userType),
        sortable: true,
      },
    
   
      {
  name: "Last Login Time",
  selector: (row) => {
    if (!row.LoginDate) return "-";
    const date = new Date(row.LoginDate);
    return date.toLocaleString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  },
  sortable: true,
}

  ];

  
  
  return (
    <div>
      <div className="form-group main_card">
      <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Not login Users/Astrologers</h2>
        <div className="row mt-3">
          <div className="col-3">
            <label className="form-label">Select Day Number</label>
            <Select
              options={options}
              className="react-select-box"
              styles={customStyles}
              value={options.find((option) => option.value === startTime)}
              onChange={(selectedOption) => setStartTime(selectedOption.value)}
              placeholder="Select a day"
             
            />
          </div>
          <div className="col-3">
          <button className="btn btn-primary mt-3" onClick={handleSearch}>
            Search
          </button>
        </div>
        </div>

       
      </div>

      <div className="col-12 mt-2 main_card">
        {loading ? (
          <Loader />
        ) : (
          <DataTable
            dense
            data={NotLoginData || []}
            columns={columns}
            selectableRowsHighlight
            pagination
            persistTableHead={true}
            noDataComponent={"There are no data to display"}
            customStyles={customStyles}
          />
        )}
      </div>
    </div>
  );
};
export default NotLoginUser;
